import { useRootStore } from '@nandosaus/state-management';
import { useEffect } from 'react';

const useLoadPastCateringOrders = () => {
  const { MemberStore, PastOrdersStore } = useRootStore();

  useEffect(() => {
    if (MemberStore.isSignedIn) {
      // loadCateringOrders returns both the active (upcoming) and past catering orders.
      PastOrdersStore.loadCateringOrders();
    }
  }, [MemberStore.isSignedIn, PastOrdersStore]);
};

export { useLoadPastCateringOrders };
